/**
 * External dependencies
 */
import React, { useState } from "react"
import { Container, Row, Col } from "react-bootstrap"
import classNames from "classnames"
/**
 * Internal dependencies
 */
import LinkIcon from "../link-icon/link-icon"
import "./styles/_index.scss"
import ContentBlock from "../content/Content";
import { useStaticQuery, graphql } from "gatsby"
import Modal from 'react-bootstrap/Modal';
import SubscribetoCatalogueForm from "../../Forms/SubscribetoCatalogue";
const AuctionCalloutBanner = (props) => {
  const [showForm, setShowForm] = useState(false);
  const openform = () => {
        setShowForm(!showForm)
  }
  const data = useStaticQuery(graphql`
  query {
    glstrapi {
      auctionCallout(publicationState: LIVE) {
        Big_Title
        Content
        Title
        Link {
          Label
          Url {
            Alias
          }
        }
      }

    }
  }
`)
  const Content = () => {


    return (
      <Row className="callout-banner__inner justify-content-lg-between bg-blue g-0 position-relative">
        <Col className="callout-banner__col position-relative">
        {data?.glstrapi?.auctionCallout?.Title && <h5>{data?.glstrapi?.auctionCallout?.Title}</h5>}

          <Row className="g-0 align-items-baseline">
            <Col xs={12} lg="auto">
              {/* {description && <p>{description}</p>} */}
              <ContentBlock Content={data?.glstrapi?.auctionCallout?.Content} />
            </Col>

            <Col xs="auto">
              {/* <a
                onClick={() => {openform()}}
                href="javascript:void(0)"
                class="link-icon blue-link-hover d-flex align-items-center"
              >
                <div
                  className={`link-icon__text fw-bolder fz14 position-relative order-0`}
                >
                  Click to find out
                </div>
                <i className={classNames(`icon icon--arrow-up-right`)}></i>
              </a> */}
               {data?.glstrapi?.auctionCallout?.Link?.Label && <LinkIcon 
            
            href={data?.glstrapi?.auctionCallout?.Link?.Url?.Alias} text={data?.glstrapi?.auctionCallout?.Link?.Label}
             />}
              {/* <LinkIcon 
            
            href={""} text={"Click to find out"}
             />      */}
            </Col>
          </Row>
        </Col>
        <Col
          lg="auto"
          className="callout-banner__col d-none d-lg-block position-relative"
        >
          <h1>strong values</h1>
        </Col>
        <Modal className="teamdetails popupForm" backdrop="static" size="lg" show={showForm} onHide={() => { setShowForm(false) }}>
          <Modal.Header closeButton>
            <Modal.Title> <div className="form__head">
              <h4>Subscribe to Catalogue</h4>
            </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <SubscribetoCatalogueForm
            />
          </Modal.Body>

        </Modal>
      </Row>
    );
  }

  return (
    <div className="callout-banner auction">
      {props?.addShell
        ? <Container fluid="hg">
          <Content  />
        </Container>
        : <Content  />
      }
    </div>
  )
}

export default AuctionCalloutBanner
